"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
PricelistService.$inject = ['api', 'extApi'];
function PricelistService(api, extApi) {
    var service = {};
    service.downloadPricelist = function (type) {
        return api.get('/b2b/pricelist', { type: type });
    };
    service.downloadXls = function () {
        return extApi.download('/pricelist/export');
    };
    return service;
}
exports.PricelistService = PricelistService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/pricelists/services/pricelist.js
// module id = 408
// module chunks = 0